// extracted by mini-css-extract-plugin
module.exports = {"overlay":"EcommerceProductListItem_overlay__8not6"};